import React from "react";

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, message: "" };
    }
    static getDerivedStateFromError(error) {
        return { hasError: true, message: error?.message || "Unexpected error" };
    }
    componentDidCatch(error, info) {
        // eslint-disable-next-line no-console
        console.error("ErrorBoundary", error, info);
    }
    render() {
        if (this.state.hasError) {
            return (
                <div className="min-h-screen bg-stone-50 flex items-center justify-center p-6">
                    <div className="max-w-md text-center">
                        <div className="w-14 h-14 rounded-full bg-red-100 text-red-700 flex items-center justify-center mx-auto mb-4 text-2xl font-bold">!</div>
                        <h1 className="font-outfit text-2xl font-semibold text-stone-900">Something went wrong</h1>
                        <p className="text-sm text-stone-500 font-dmsans mt-2">{this.state.message}</p>
                        <button
                            onClick={() => window.location.assign("/")}
                            className="mt-6 rounded-full bg-emerald-700 hover:bg-emerald-800 text-white px-6 h-11 font-medium"
                        >
                            Back to home
                        </button>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}
